// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3oBRa","vLegacy":"SelectSecondary_vLegacy__3n66K","error":"SelectSecondary_error__1EoMG","disabled":"SelectSecondary_disabled__1tVIV"};